import { render, staticRenderFns } from "./BlockType3List.vue?vue&type=template&id=43793982&scoped=true&"
import script from "./BlockType3List.vue?vue&type=script&lang=ts&"
export * from "./BlockType3List.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType3List.vue?vue&type=style&index=0&id=43793982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43793982",
  null
  
)

export default component.exports